import { useQuery } from '@tanstack/react-query';

import { BaseError } from './../../helpers/BaseError';

// models
import { MetricInfoModel } from '../../models/metrics.model';

// services
import API from '../../services/api';

// constant
import metricKeys from './_queryKeys';

const getInfo = async (): Promise<Record<string, MetricInfoModel>> => {
    const { data } = await API.getMetricsInfo();
    return data;
};

export default function useMetricsInfo() {
    return useQuery<Record<string, MetricInfoModel>, BaseError>({
        queryKey: metricKeys.metricsInfo(),
        queryFn: () => getInfo(),
        staleTime: 60 * 60 * 2 * 1000,
    });
}
